module.exports = __webpack_public_path__ + "static/media/vision_center.15864440.png";